import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppointmentService } from 'src/app/private/services/appointment.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TimerService } from 'src/app/utils/timer.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Chart from 'chart.js/auto';

export class Vitals {
  bp: string = "";
  hr: string = "";
  temp: string = "";
  weight: string = "";
  bmi: string = "";
}

export class Patient {
  id!: Number;
  pId:string = "";
  fname: string = "";
  lname: string = "";
  prefix: string = "";
  gender: string = "";
  blood_group:string = "";
  age: Number = 0;
  email: string = "";
  mobile: string = "";
  address: string = "";
  photo: string = "";
}

@Component({
  selector: 'app-ipd-dashboard',
  templateUrl: './ipd-dashboard.component.html',
  styleUrls: ['./ipd-dashboard.component.scss']
})
export class IpdDashboardComponent {
  active = "patient_details"
  patient_id = 0;
  current_app_id = 0;
  currentAppointment:any;
  currentDashabord:any;
  patient: Patient = new Patient();
  modules:any = [];
  permissions:any = [];
  pId = "";
  loading: boolean = true;
  
  vitals: Vitals = new Vitals();
  vitalsHistory: any[] = [];
  activeTrendMetric: string = 'bp';
  vitalsChartInstance: any = null;
  activeHistoryTab: string = 'trend';
  savingVitals: boolean = false;
  loadingVitals: boolean = false;
  uploadingAvatar: boolean = false;
  
  loadingJourney: boolean = true;
  journeyEvents: any[] = [];
  isSidebarOpen: boolean = true;

  constructor(
    public route:ActivatedRoute,
    private api:UsersService,
    private appointmentApi: AppointmentService,
    private localStorage:LocalStorageService,
    private modalService: NgbModal,
    public timerService: TimerService
  ) {}

  ngOnInit(){
    this.route.params.subscribe(params => {
      this.currentDashabord = this.route.snapshot.data['dashabord'] || "";
      this.patient_id = params['id']
      this.current_app_id = params['ipd_app_id']
    })
  
    let param = {
      where:{
        hospital_id:this.localStorage.getHospitalId(),
        center_id:this.localStorage.getCenterId(),
        pId:localStorage.getItem('pId')
      }
    }
    this.api.getPatientById(param).subscribe({
      next:(res)=>{
        this.loading = false;
        this.patient = res;
        this.pId = res.pId
        localStorage.setItem('pId', res.pId);
        this.currentAppointment = res;
        if(res.advanceDeposit) {
          if(res.advanceDeposit.amount) {
            localStorage.setItem('advanceDeposit', res.advanceDeposit.amount);
          }
        }
        this.loadVitals();
        this.loadPatientJourney();
      },
      error:(e)=>{
        this.loading = false;
      }
    })
    this.permissions = JSON.parse(this.localStorage.getPermissions());   
    this.modules =  JSON.parse(JSON.stringify(this.localStorage.getFeatureModules()));
  }

  loadPatientJourney() {
    this.loadingJourney = true;
    this.appointmentApi.getPatientJourney({ patient_id: this.patient_id }).subscribe({
      next: (historyRes) => {
        this.journeyEvents = (historyRes || []).map((item: any) => ({
          ...item,
          date: item.createdAt || item.date
        }));
        this.loadingJourney = false;
      },
      error: (e) => {
        this.journeyEvents = [];
        this.loadingJourney = false;
      }
    });
  }

  getfeatureAccess(module_name:any,feature_name:any) {
    let feature  = [];
    let module = [];
    module = this.permissions.filter((item:any)=>{
      return  item.module_name  == module_name;
    })
    if(module.length > 0) {
      feature = module[0]['features'].filter((item:any)=>{
        return  item.name  == feature_name;
      })
    }
    return (module[0] && feature[0] ) ? true : false;
  } 

  getFeatureModuleAccess(module_name:any) {
    return (this.modules.includes(module_name) ? true : false);
  }

  goToDischarge() {
    this.active = 'discharge_summery'
  }

  onFileSelected(event: any) {
    // Basic placeholder method for file selection
  }

  openModal(content: any) {
    this.modalService.open(content, { centered: true, size: 'md' });
  }

  openVitalsHistoryModal(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
    setTimeout(() => {
      this.initVitalsChart();
    }, 150);
  }

  loadVitals() {
    this.loadingVitals = true;
    this.appointmentApi.getVitals({ patient_id: this.patient_id }).subscribe({
      next: (vitalsRes) => {
        if (vitalsRes) {
          if (Array.isArray(vitalsRes)) {
            this.vitals = vitalsRes[0] || new Vitals();
            this.vitalsHistory = vitalsRes;
          } else if (vitalsRes.history) {
            this.vitals = vitalsRes.latest || new Vitals();
            this.vitalsHistory = vitalsRes.history || [];
          } else {
            this.vitals = vitalsRes;
            this.vitalsHistory = [vitalsRes];
          }
        } else {
          this.vitals = new Vitals();
          this.vitalsHistory = [];
        }
        this.loadingVitals = false;
      },
      error: (e) => {
        console.error("Error loading vitals:", e);
        this.loadingVitals = false;
      }
    });
  }

  saveVitals(modal: any) {
    this.savingVitals = true;
    const payload = {
      ...this.vitals,
      patient_id: this.patient_id,
      app_id: this.current_app_id
    };
    this.appointmentApi.saveVitals(payload).subscribe({
      next: (res) => {
        this.savingVitals = false;
        modal.close();
        this.loadVitals();
      },
      error: (err) => {
        console.error('Error saving vitals', err);
        this.savingVitals = false;
        modal.close();
      }
    });
  }

  getVitalStatus(type: string, value: any): 'normal' | 'warning' | 'danger' | 'neutral' {
    if (value === undefined || value === null || value === '' || value === '-') return 'neutral';
    const valStr = String(value).trim();
    if (!valStr) return 'neutral';

    switch (type) {
      case 'bp': {
        const parts = valStr.split('/');
        if (parts.length !== 2) return 'neutral';
        const sys = parseInt(parts[0], 10);
        const dia = parseInt(parts[1], 10);
        if (isNaN(sys) || isNaN(dia)) return 'neutral';
        if (sys >= 140 || dia >= 90) return 'danger';
        if (sys < 90 || dia < 60) return 'danger';
        if (sys > 120 || dia > 80) return 'warning';
        return 'normal';
      }
      case 'hr': {
        const hr = parseInt(valStr, 10);
        if (isNaN(hr)) return 'neutral';
        if (hr < 50 || hr > 120) return 'danger';
        if ((hr >= 50 && hr < 60) || (hr > 100 && hr <= 120)) return 'warning';
        return 'normal';
      }
      case 'temp': {
        const temp = parseFloat(valStr);
        if (isNaN(temp)) return 'neutral';
        if (temp > 101.0 || temp < 95.0) return 'danger';
        if ((temp >= 99.1 && temp <= 101.0) || (temp >= 95.0 && temp < 97.0)) return 'warning';
        return 'normal';
      }
      case 'bmi': {
        const bmi = parseFloat(valStr);
        if (isNaN(bmi)) return 'neutral';
        if (bmi >= 30.0 || bmi < 16.0) return 'danger';
        if ((bmi >= 25.0 && bmi < 30.0) || (bmi >= 16.0 && bmi < 18.5)) return 'warning';
        return 'normal';
      }
      case 'weight': {
        if (this.vitals && this.vitals.bmi) return this.getVitalStatus('bmi', this.vitals.bmi);
        return 'neutral';
      }
      default: return 'neutral';
    }
  }

  getVitalClass(type: string, value: any): string {
    const status = this.getVitalStatus(type, value);
    return `vital-item text-center vital-${status}`;
  }

  changeTrendMetric(metric: string) {
    this.activeTrendMetric = metric;
    this.initVitalsChart();
  }

  setHistoryTab(tab: string) {
    this.activeHistoryTab = tab;
    if (tab === 'trend') {
      setTimeout(() => {
        this.initVitalsChart();
      }, 50);
    }
  }

  initVitalsChart() {
    const canvas = document.getElementById('vitalsHistoryChart') as HTMLCanvasElement;
    if (!canvas) return;

    if (this.vitalsChartInstance) {
      this.vitalsChartInstance.destroy();
      this.vitalsChartInstance = null;
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const chronologicalHistory = [...this.vitalsHistory].reverse();
    const validEntries = chronologicalHistory.filter(item => {
      const val = item[this.activeTrendMetric];
      return val !== undefined && val !== null && String(val).trim() !== '' && String(val).trim() !== '-';
    });

    const labels = validEntries.map(item => {
      const date = new Date(item.createdAt);
      return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: '2-digit' }) + ' ' + 
             date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
    });

    let data: number[] = [];
    let label = '';
    let borderColor = '#1b6281';
    let backgroundColor = 'rgba(27, 98, 129, 0.1)';

    if (this.activeTrendMetric === 'bp') {
      const sysData = validEntries.map(item => parseInt(String(item.bp).split('/')[0], 10) || 0);
      const diaData = validEntries.map(item => parseInt(String(item.bp).split('/')[1], 10) || 0);

      this.vitalsChartInstance = new Chart(ctx, {
        type: 'line',
        data: {
          labels,
          datasets: [
            {
              label: 'Systolic mmHg',
              data: sysData,
              borderColor: '#ef4444',
              backgroundColor: 'rgba(239, 68, 68, 0.08)',
              borderWidth: 3,
              tension: 0.3,
              fill: true,
              pointBackgroundColor: '#ef4444',
              pointRadius: 4
            },
            {
              label: 'Diastolic mmHg',
              data: diaData,
              borderColor: '#3b82f6',
              backgroundColor: 'rgba(59, 130, 246, 0.08)',
              borderWidth: 3,
              tension: 0.3,
              fill: true,
              pointBackgroundColor: '#3b82f6',
              pointRadius: 4
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true, position: 'top', labels: { font: { family: 'Inter', size: 12 } } },
            tooltip: { mode: 'index', intersect: false, bodyFont: { family: 'Inter' }, titleFont: { family: 'Inter', weight: 'bold' } }
          },
          scales: {
            x: { grid: { display: false }, ticks: { font: { family: 'Inter', size: 10 } } },
            y: { grid: { color: '#f1f2f6' }, ticks: { font: { family: 'Inter', size: 10 } } }
          }
        }
      });
      return;
    }

    if (this.activeTrendMetric === 'hr') {
      label = 'Heart Rate (bpm)';
      borderColor = '#f59e0b';
      backgroundColor = 'rgba(245, 158, 11, 0.08)';
      data = validEntries.map(item => parseInt(item.hr, 10) || 0);
    } else if (this.activeTrendMetric === 'temp') {
      label = 'Temperature (°F)';
      borderColor = '#ef4444';
      backgroundColor = 'rgba(239, 68, 68, 0.08)';
      data = validEntries.map(item => parseFloat(item.temp) || 0);
    } else if (this.activeTrendMetric === 'weight') {
      label = 'Weight (kg)';
      borderColor = '#10b981';
      backgroundColor = 'rgba(16, 185, 129, 0.08)';
      data = validEntries.map(item => parseFloat(item.weight) || 0);
    } else if (this.activeTrendMetric === 'bmi') {
      label = 'BMI';
      borderColor = '#8b5cf6';
      backgroundColor = 'rgba(139, 92, 246, 0.08)';
      data = validEntries.map(item => parseFloat(item.bmi) || 0);
    }

    this.vitalsChartInstance = new Chart(ctx, {
      type: 'line',
      data: {
        labels,
        datasets: [{ label, data, borderColor, backgroundColor, borderWidth: 3, tension: 0.3, fill: true, pointBackgroundColor: borderColor, pointRadius: 4 }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: true, position: 'top', labels: { font: { family: 'Inter', size: 12 } } },
          tooltip: { mode: 'index', intersect: false, bodyFont: { family: 'Inter' }, titleFont: { family: 'Inter', weight: 'bold' } }
        },
        scales: {
          x: { grid: { display: false }, ticks: { font: { family: 'Inter', size: 10 } } },
          y: { grid: { color: '#f1f2f6' }, ticks: { font: { family: 'Inter', size: 10 } } }
        }
      }
    });
  }
}